import { graphql, useStaticQuery } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { IStaticContentfulImages } from 'src/types/contentful';
import { FromIdeaImage, FromIdeaImageSliderContainer } from './FromIdeaImageSlide.styles';
import { GatsbyImage } from 'gatsby-plugin-image';

const FromIdeaImageSlide = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      styleHub: contentfulAsset(contentful_id: { eq: "2VAbzgBGgANda6BJcRSrPa" }) {
        gatsbyImageData(width: 1800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      focusFoodies: contentfulAsset(contentful_id: { eq: "6PjvoDe6Pti6i7oz8QjVnu" }) {
        gatsbyImageData(width: 1800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      midModMania: contentfulAsset(contentful_id: { eq: "hziiUG8CqYFpez5b9ASMm" }) {
        gatsbyImageData(width: 1800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      getFitWithAlex: contentfulAsset(contentful_id: { eq: "3yIJRzXwMmZJWGm2qyiOb6" }) {
        gatsbyImageData(width: 1800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      laughLeague: contentfulAsset(contentful_id: { eq: "7sVvFo86kwjbxkD2u3CENt" }) {
        gatsbyImageData(width: 1800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      pageTurner: contentfulAsset(contentful_id: { eq: "2MFi8zw4ELqQXBkq0TNSYr" }) {
        gatsbyImageData(width: 1800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      canineCompanion: contentfulAsset(contentful_id: { eq: "4MoibQxkkHtzBiHSNtHTTm" }) {
        gatsbyImageData(width: 1800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      animeBrigade: contentfulAsset(contentful_id: { eq: "5xUUJ7fj9sVsc5LJGhKhuj" }) {
        gatsbyImageData(width: 1800, layout: CONSTRAINED, placeholder: BLURRED)
      }
      rockRenegades: contentfulAsset(contentful_id: { eq: "7G8iZMNQAxBxD4ClLxsQEd" }) {
        gatsbyImageData(width: 1800, layout: CONSTRAINED, placeholder: BLURRED)
      }
    }
  `);

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % Object.keys(images).length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const getSlideState = (index: number): 'active' | 'hidden' => {
    if (index === currentSlide) {
      return 'active';
    }

    return 'hidden';
  };

  return (
    <FromIdeaImageSliderContainer>
      {Object.keys(images).map((slideKey, index) => (
        <FromIdeaImage
          state={getSlideState(index)}
          key={slideKey}
        >
          <GatsbyImage
            image={images[slideKey].gatsbyImageData}
            alt={slideKey}
          />
        </FromIdeaImage>
      ))}
    </FromIdeaImageSliderContainer>
  );
};

export default FromIdeaImageSlide;
